import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static values = { format: String, attr: String }

  connect() {
    reactor(this)
    this.render()
  }

  morph() {
    this.render()
  }

  render() {
    const datetime = this.element.getAttribute("datetime")
    if (!datetime) return
    const date = new Date(datetime)
    if (this.attrValue) {
      this.element.setAttribute(this.attrValue, this.format(date))
    } else {
      this.element.textContent = this.format(date)
    }
  }

  format(date) {
    switch (this.formatValue) {
      case "datetime":
        return this.datetime(date)
      case "time":
        return this.time(date)
      default:
        return this.timeDate(date)
    }
  }

  time(date) {
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
  }

  timeDate(date) {
    const pad = (n) => String(n).padStart(2, "0")
    const mon = date.toLocaleString(undefined, { month: "short" })
    return `${mon} ${pad(date.getDate())}, ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  }

  datetime(date) {
    return (
      date.toLocaleDateString(undefined, {
        month: "long",
        day: "numeric",
        year: "numeric",
      }) +
      " at " +
      date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    )
  }
}
